export class StatusConstants {
    public static readonly PENDING_STATUS = "Pending";
    public static readonly ACCEPTED_STATUS = "Accepted";
    public static readonly DECLINED_STATUS = "Denied";
}
